/*
 * Flight-Lab Studio – Live-Konfigurator für lasergravierte Target K-Flex
 * --------------------------------------------------------------------
 * Ohne Frameworks. Wird von sections/flight-lab-studio.liquid geladen.
 *
 * Was passiert hier:
 *  - Motiv (Bild) und/oder Text werden auf eine flach gelegte Flight-Seite gelegt
 *    (beide Flügel + Mittelrippe, so wie die Flight in der Werkstatt unter dem Laser liegt)
 *  - daraus wird eine Gravur-Maske berechnet (Logo = scharf, Foto = gerastert)
 *  - die Maske wird auf die Seiten eines 3D-K-Flex gezeichnet (drehbar)
 *  - zusätzlich eine hochaufgelöste Laser-Maske (schwarz = gravieren), aus der
 *    das Backend die fertige xTool-Studio-Datei (.xs) baut
 *  - beim Kauf werden Originaldatei, Vorschau und Design-Daten an das
 *    Backend (App-Proxy -> Cloud Run -> Google Drive) geschickt und als
 *    Eigenschaften an die Warenkorb-Position gehängt
 *
 * Flügel-Geometrie: Die Pfade in SHAPES sind Näherungen. Für millimeter-
 * genaue Vorschau die echten Laser-Vorlagen als SVG-Pfad (Koordinaten
 * 0..200 x 0..260, Schaft links, Hinterkante oben) in den Section-
 * Einstellungen hinterlegen – sie überschreiben diese Werte.
 */
(function () {
  'use strict';

  /* ------------------------------------------------------------------ */
  /* Grundwerte                                                          */
  /* ------------------------------------------------------------------ */

  // Ein Flügel: vom Schaft (x = 0) nach außen, Spitze/Hinterkante oben, Hals (Übergang zum Schaft) unten.
  // Konturen 1:1 nachgezeichnet: No.2 aus Targets offizieller K-Flex-Maßzeichnung (Gesamtlänge Short 61,6 mm),
  // No.6 aus Targets Verpackungsfoto (flache Ansicht). Maßstab: 250 Einheiten = 38,1 mm Flügellänge.
  var W = 112; // Breite eines Flügels in Vorlagen-Einheiten (Flügel max. ca. 15,6 mm)
  var H = 260; // Länge vom Rand oben bis zum Hals
  var RES = 3; // Pixel pro Einheit für die Canvas
  var SPINE = 4.5; // halbe Breite der Mittelrippe (Rippe ca. 2 mm)
  var MM = 250 / 38.1; // Einheiten pro Millimeter
  var PW = W * 2;      // eine Flight-Seite: linker + rechter Flügel, Mittelrippe bei x = W
  var ENG_H = 218;     // gravierbar bis hierhin (darunter Hals/Schaft)
  var LRES = 6;        // Pixel pro Einheit für die Laser-Maske (ca. 39 px/mm)

  var SHAPES = {
    'No.2': 'M0 12.1 L9.0 12.1 L13.4 14.5 L67.3 36.4 L77.6 41.3 L87.3 48.6 L93.9 56.7 L99.7 68.9 L101.9 78.6 L101.9 92.4 L96.6 172.0 L94.8 177.6 L90.1 184.1 L30.8 243.4 L18.8 258.0 L0 258 Z',
    'No.6': 'M0 8.0 L8.6 8.0 L72.0 33.9 L81.5 38.8 L93.7 49.8 L99.3 57.8 L101.2 63.0 L103.6 80.6 L103.5 92.6 L98.5 159.3 L98.5 167.2 L95.7 176.2 L91.6 182.1 L15.2 258.8 L0 258 Z'
  };

  // Gravurfarben je K-Flex-Farbe (wie sieht der Laser auf dem Material aus)
  var MATERIALS = {
    'Schwarz': { base: '#1c1d1f', sheen: '#3a3c40', mark: [214, 214, 208], sides: 4 },
    'Weiß':    { base: '#f2f2ef', sheen: '#ffffff', mark: [126, 118, 108], sides: 4 },
    'Blau':    { base: '#1f4fb4', sheen: '#3f72d8', mark: [196, 214, 245], sides: 4 }
  };
  var DEFAULT_MATERIAL = { base: '#888888', sheen: '#aaaaaa', mark: [255, 255, 255], sides: 2 };

  var SHAFT_MM = { 'Short': 19, 'Intermediate': 26, 'Medium': 33 };

  var FONTS = [
    { id: 'Oswald', label: 'Kantig', css: 'Oswald:wght@600' },
    { id: 'Bebas Neue', label: 'Plakat', css: 'Bebas+Neue' },
    { id: 'Black Ops One', label: 'Stencil', css: 'Black+Ops+One' },
    { id: 'Permanent Marker', label: 'Marker', css: 'Permanent+Marker' },
    { id: 'Pacifico', label: 'Schwung', css: 'Pacifico' },
    { id: 'Cinzel', label: 'Klassisch', css: 'Cinzel:wght@700' }
  ];

  var TIERS = [
    { min: 10, pct: 15 },
    { min: 5, pct: 10 }
  ];

  /* ------------------------------------------------------------------ */
  /* Kleine Helfer                                                       */
  /* ------------------------------------------------------------------ */

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function el(tag, attrs, children) {
    var n = document.createElement(tag);
    if (attrs) Object.keys(attrs).forEach(function (k) {
      if (k === 'class') n.className = attrs[k];
      else if (k === 'text') n.textContent = attrs[k];
      else if (k.indexOf('on') === 0) n.addEventListener(k.slice(2), attrs[k]);
      else n.setAttribute(k, attrs[k]);
    });
    (children || []).forEach(function (c) { if (c) n.appendChild(typeof c === 'string' ? document.createTextNode(c) : c); });
    return n;
  }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }
  function money(cents, currency) {
    try {
      return new Intl.NumberFormat('de-DE', { style: 'currency', currency: currency || 'EUR' }).format(cents / 100);
    } catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function uid() { return 'd' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7); }
  function store(key, val) {
    try {
      if (val === undefined) return JSON.parse(localStorage.getItem(key) || 'null');
      localStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function loadFonts() {
    if (document.getElementById('fls-studio-fonts')) return;
    var href = 'https://fonts.googleapis.com/css2?' + FONTS.map(function (f) { return 'family=' + f.css; }).join('&') + '&display=swap';
    document.head.appendChild(el('link', { id: 'fls-studio-fonts', rel: 'stylesheet', href: href }));
  }

  /* ------------------------------------------------------------------ */
  /* Studio                                                              */
  /* ------------------------------------------------------------------ */

  function Studio(root) {
    this.root = root;
    var cfgNode = $('script[data-fl-studio-config]', root);
    this.cfg = cfgNode ? JSON.parse(cfgNode.textContent) : {};
    this.product = this.cfg.product;
    this.proxy = this.cfg.proxy || '/apps/flstudio';
    this.offline = !!this.cfg.offline; // Demo-Modus ohne Backend
    this.uvOnly = /UV-Farbdruck/i.test((this.cfg.product && this.cfg.product.title) || ''); this.uvProduct = this.cfg.uvProduct && this.cfg.uvProduct.variants && this.cfg.uvProduct.variants.length ? this.cfg.uvProduct : null;
    // Unbedruckter Rand an der Flügelaußenkante (Druckform hält den Flügel dort fest), in mm. 0 = randlos.
    this.edgeMm = Math.max(0, parseFloat(this.cfg.edgeMm) || 0);
    // Flight-Farben, die beim UV-Farbdruck angeboten werden (leer = alle)
    this.uvColors = String(this.cfg.uvColors != null ? this.cfg.uvColors : 'Weiß').split(',').map(function (x) { return x.trim(); }).filter(Boolean);
    if (this.cfg.shapes) Object.keys(this.cfg.shapes).forEach(function (k) { if (this.cfg.shapes[k]) SHAPES[k] = this.cfg.shapes[k]; }, this);

    this.state = {
      options: {},
      method: 'laser',         // laser | uv
      mode: 'single',          // single | team
      layers: {
        image: null,           // { img, file, name, x, y, scale, rot, kind: 'logo'|'photo', invert, threshold }
        text: { lines: ['', ''], font: FONTS[0].id, color: '#ffffff', x: W, y: H * 0.4, scale: 0.85, rot: 0, enabled: true }
      },
      active: 'text',
      players: [{ name: '', extra: '' }],
      playerIndex: 0,
      qty: 1,
      angle: 0,
      reveal: 1
    };

    this.wingPath = null;
    this.maskCanvas = document.createElement('canvas');   // ganze Flight-Seite
    this.maskCanvas.width = PW * RES; this.maskCanvas.height = H * RES;
    this.build();
    this.selectDefaultVariant();
    this.render();
    this.loop();
    this.loadSavedDesigns();
  }

  /* ---------- Varianten -------------------------------------------- */

  Studio.prototype.selectDefaultVariant = function () {
    var v = this.product.variants.filter(function (x) { return x.available !== false; })[0] || this.product.variants[0];
    var self = this;
    this.product.options.forEach(function (name, i) { self.state.options[name] = v.options[i]; });
    this.syncOptionButtons();
  };

  Studio.prototype.currentVariant = function () {
    var self = this;
    var match = function (prod) {
      return prod.variants.filter(function (v) {
        return self.product.options.every(function (name, i) { return v.options[i] === self.state.options[name]; });
      })[0];
    };
    // UV-Farbdruck läuft über ein eigenes Produkt (gleiche Optionen, eigener Preis)
    if (this.isUV() && this.uvProduct) return match(this.uvProduct) || match(this.product);
    return match(this.product);
  };

  Studio.prototype.optionValue = function (re) {
    var self = this, hit = null;
    this.product.options.forEach(function (name) { if (re.test(name)) hit = self.state.options[name]; });
    return hit;
  };

  // Verfahren: Lasergravur oder UV-Farbdruck (Produktoption „Verfahren“)
  Studio.prototype.isUV = function () {
    return this.state.method === 'uv';
  };
  Studio.prototype.setMethod = function (m) {
    if (this.uvOnly) { m = 'uv'; if (this.methodRow) this.methodRow.hidden = true; } this.state.method = m;
    $all('.fls-chip', this.methodRow).forEach(function (b) {
      var on = b.getAttribute('data-method') === m; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
    });
    this.applyMethodColors();
    this.updatePrice && this.updatePrice();
    this.render(true);
  };
  // Beim UV-Farbdruck nur die freigegebenen Flight-Farben zeigen (z. B. nur Weiß)
  Studio.prototype.applyMethodColors = function () {
    var self = this, uv = this.isUV(), allowed = this.uvColors;
    Object.keys(this.optionGroups || {}).forEach(function (name) {
      if (!/farbe|color/i.test(name)) return;
      var first = null;
      $all('.fls-chip', self.optionGroups[name]).forEach(function (b) {
        var ok = !uv || !allowed.length || allowed.indexOf(b.getAttribute('data-value')) >= 0;
        b.hidden = !ok;
        if (ok && first === null) first = b.getAttribute('data-value');
      });
      if (self.colorNote) {
        self.colorNote.hidden = !(uv && allowed.length);
        self.colorNote.textContent = 'UV-Farbdruck gibt es aktuell nur auf K-Flex in ' + allowed.join(', ') + '. Für andere Farben wähle die Lasergravur.';
      }
      if (uv && allowed.length && allowed.indexOf(self.state.options[name]) < 0 && first !== null) self.state.options[name] = first;
    });
    this.syncOptionButtons();
  };

  // Unbedruckter Rand gilt nur beim UV-Druck (Druckform hält den Flügel am Rand)
  Studio.prototype.edge = function () { return this.isUV() ? this.edgeMm : 0; };

  Studio.prototype.shapeKey = function () {
    var f = this.optionValue(/form|shape|größe/i) || 'No.2';
    return /6/.test(f) ? 'No.6' : 'No.2';
  };
  Studio.prototype.material = function () {
    var c = this.optionValue(/farbe|color|colour/i) || 'Schwarz';
    return MATERIALS[c] || DEFAULT_MATERIAL;
  };
  Studio.prototype.shaftMM = function () {
    var l = this.optionValue(/länge|laenge|length/i) || 'Short';
    var key = Object.keys(SHAFT_MM).filter(function (k) { return l.indexOf(k) === 0; })[0];
    return SHAFT_MM[key] || 19;
  };

  /* ---------- Aufbau der Oberfläche -------------------------------- */

  Studio.prototype.build = function () {
    var self = this;
    var r = this.root;
    r.classList.add('fls-studio');

    // Bühne mit 3D-Flight
    this.stage = el('div', { class: 'fls-stage', role: 'img', 'aria-label': 'Live-Vorschau deines K-Flex. Zum Drehen ziehen.' });
    // K-Flex = zwei Flügel-Ebenen aus einem Guss, um 90° gekreuzt, dazu der angespritzte Schaft
    this.rig = el('div', { class: 'fls-rig' });
    this.planes = [];
    // Jeder der 4 Flügel ist ein eigenes Element, das nur an der Mittelrippe anstößt –
    // sich schneidende Ebenen stellen Browser (v. a. Safari) beim Drehen oft falsch dar.
    for (var i = 0; i < 2; i++) {
      var wings = ['L', 'R'].map(function (side) {
        var f = el('canvas', { class: 'fls-plane__face', width: W * RES, height: H * RES });
        var b = el('canvas', { class: 'fls-plane__face fls-plane__face--back', width: W * RES, height: H * RES });
        var node = el('div', { class: 'fls-wing fls-wing--' + side }, [f, b]);
        node.style.transform = 'rotateY(' + (i * -90) + 'deg)';
        this.rig.appendChild(node);
        return { node: node, front: f, back: b };
      }, this);
      this.planes.push({ L: wings[0], R: wings[1] });
    }
    this.shaft = el('div', { class: 'fls-shaft' }, [
      el('span', { class: 'fls-shaft__body' }), el('span', { class: 'fls-shaft__collar' }), el('span', { class: 'fls-shaft__thread' })
    ]);
    this.laser = el('div', { class: 'fls-laser', 'aria-hidden': 'true' });
    this.obj = el('div', { class: 'fls-obj' }, [this.shaft, this.rig, this.laser]);
    this.stage.appendChild(el('div', { class: 'fls-stage__bed', 'aria-hidden': 'true' }));
    this.stage.appendChild(this.obj);

    this.viewBtns = el('div', { class: 'fls-stage__views' }, [
      el('button', { type: 'button', class: 'fls-chip fls-chip--dark', 'data-view': '35', text: 'Schräg', onclick: function () { self.turnTo(28); } }),
      el('button', { type: 'button', class: 'fls-chip fls-chip--dark', 'data-view': '0', text: 'Seite', onclick: function () { self.turnTo(0); } }),
      el('button', { type: 'button', class: 'fls-chip fls-chip--dark', 'data-view': 'spin', text: 'Drehen', onclick: function () { self.spin = !self.spin; this.setAttribute('aria-pressed', self.spin); } })
    ]);
    this.stageNote = el('p', { class: 'fls-stage__note' });
    this.stage.appendChild(this.viewBtns);
    this.stage.appendChild(this.stageNote);
    this.bindDrag();

    // Editor (flach gelegte Flight-Seite zum Positionieren)
    this.editor = el('canvas', { class: 'fls-editor__canvas', width: PW * RES, height: H * RES, tabindex: '0',
      'aria-label': 'Motiv auf der Flight positionieren. Pfeiltasten verschieben, Plus und Minus skalieren.' });
    this.bindEditor();

    var panel = el('div', { class: 'fls-panel' });

    // Kopf
    panel.appendChild(el('div', { class: 'fls-head' }, [
      el('h1', { class: 'fls-title', text: this.product.title }),
      this.priceNode = el('p', { class: 'fls-price' }),
      this.subNode = el('p', { class: 'fls-sub', text: '1 Set = 3 Flights · aus unserer Werkstatt am Bodensee' })
    ]));

    // Verfahren: Lasergravur oder UV-Farbdruck
    this.methodRow = el('div', { class: 'fls-chips', role: 'radiogroup', 'aria-label': 'Verfahren' }, [
      el('button', { type: 'button', class: 'fls-chip is-on', role: 'radio', 'aria-checked': 'true', 'data-method': 'laser', text: 'Lasergravur', onclick: function () { self.setMethod('laser'); } }),
      el('button', { type: 'button', class: 'fls-chip', role: 'radio', 'aria-checked': 'false', 'data-method': 'uv', text: 'UV-Farbdruck', onclick: function () { self.setMethod('uv'); } })
    ]);
    panel.appendChild(el('fieldset', { class: 'fls-group' }, [el('legend', { text: 'Verfahren' }), this.methodRow,
      this.methodNote = el('p', { class: 'fls-hint fls-hint--method' })]));

    // Optionen (Form, Länge, Farbe)
    this.optionGroups = {};
    this.product.options.forEach(function (name, idx) {
      var values = [];
      self.product.variants.forEach(function (v) { if (values.indexOf(v.options[idx]) < 0) values.push(v.options[idx]); });
      var row = el('div', { class: 'fls-chips', role: 'radiogroup', 'aria-label': name });
      values.forEach(function (val) {
        var isColor = /farbe|color/i.test(name);
        var b = el('button', { type: 'button', class: 'fls-chip' + (isColor ? ' fls-chip--swatch' : ''), role: 'radio', 'data-option': name, 'data-value': val,
          onclick: function () { self.state.options[name] = val; self.syncOptionButtons(); self.render(true); } });
        if (isColor) {
          var m = MATERIALS[val] || DEFAULT_MATERIAL;
          b.appendChild(el('span', { class: 'fls-swatch', style: 'background:' + m.base }));
        }
        b.appendChild(document.createTextNode(val));
        row.appendChild(b);
      });
      var fsKids = [el('legend', { text: name }), row];
      if (/farbe|color/i.test(name)) fsKids.push(self.colorNote = el('p', { class: 'fls-hint', hidden: '' }));
      var fs = el('fieldset', { class: 'fls-group' }, fsKids);
      panel.appendChild(fs);
      self.optionGroups[name] = row;
    });

    // Modus: Einzeln / Team
    this.modeRow = el('div', { class: 'fls-tabs', role: 'tablist' }, [
      el('button', { type: 'button', role: 'tab', class: 'fls-tab', 'data-mode': 'single', text: 'Für mich', onclick: function () { self.setMode('single'); } }),
      el('button', { type: 'button', role: 'tab', class: 'fls-tab', 'data-mode': 'team', text: 'Fürs Team', onclick: function () { self.setMode('team'); } })
    ]);
    panel.appendChild(this.modeRow);

    // Motiv-Bereich
    var design = el('div', { class: 'fls-design' });

    // Upload
    this.fileInput = el('input', { type: 'file', accept: 'image/png,image/jpeg,image/webp,image/svg+xml', class: 'fls-visually-hidden', id: 'fls-file-' + this.product.id });
    this.fileInput.addEventListener('change', function () { if (this.files[0]) self.loadImage(this.files[0]); });
    this.drop = el('label', { class: 'fls-drop', for: this.fileInput.id }, [
      el('strong', { text: 'Logo oder Foto hochladen' }),
      el('span', { text: 'PNG, JPG, WEBP oder SVG – einfach hierher ziehen' })
    ]);
    ['dragenter', 'dragover'].forEach(function (ev) { self.drop.addEventListener(ev, function (e) { e.preventDefault(); self.drop.classList.add('is-over'); }); });
    ['dragleave', 'drop'].forEach(function (ev) { self.drop.addEventListener(ev, function (e) { e.preventDefault(); self.drop.classList.remove('is-over'); }); });
    this.drop.addEventListener('drop', function (e) { var f = e.dataTransfer.files[0]; if (f) self.loadImage(f); });

    this.imageTools = el('div', { class: 'fls-imagetools', hidden: '' }, [
      el('div', { class: 'fls-chips fls-chips--small', role: 'radiogroup', 'aria-label': 'Motivart' }, [
        el('button', { type: 'button', class: 'fls-chip', 'data-kind': 'logo', text: 'Logo (scharf)', onclick: function () { self.setImage({ kind: 'logo' }); } }),
        el('button', { type: 'button', class: 'fls-chip', 'data-kind': 'photo', text: 'Foto (gerastert)', onclick: function () { self.setImage({ kind: 'photo' }); } })
      ]),
      this.rangeRow('Feinheit', 'threshold', 20, 235, 128, function (v) { self.setImage({ threshold: v }); }),
      el('div', { class: 'fls-row' }, [
        el('button', { type: 'button', class: 'fls-link', text: 'Motiv entfernen', onclick: function () { self.removeImage(); } })
      ])
    ]);

    design.appendChild(el('fieldset', { class: 'fls-group' }, [el('legend', { text: 'Dein Motiv' }), this.fileInput, this.drop, this.imageTools]));

    // Text
    this.textSingle = el('div', { class: 'fls-textfields' }, [
      this.textField('Name oder Spruch', 0, 'z. B. THE HAMMER'),
      this.textField('Zweite Zeile (optional)', 1, 'z. B. Rähna Dart 1')
    ]);
    this.teamBox = el('div', { class: 'fls-team', hidden: '' });
    this.fontRow = el('div', { class: 'fls-fonts', role: 'radiogroup', 'aria-label': 'Schrift' });
    FONTS.forEach(function (f) {
      self.fontRow.appendChild(el('button', { type: 'button', class: 'fls-font', role: 'radio', 'data-font': f.id, style: 'font-family:"' + f.id + '"',
        text: 'Abc', title: f.label, onclick: function () { self.state.layers.text.font = f.id; self.syncFonts(); self.render(true); } }));
    });
    this.inkRow = el('div', { class: 'fls-inks', role: 'radiogroup', 'aria-label': 'Textfarbe', hidden: '' });
    INK.forEach(function (c) {
      self.inkRow.appendChild(el('button', { type: 'button', class: 'fls-ink', role: 'radio', 'data-ink': c.id, title: c.label, 'aria-label': c.label,
        style: 'background:' + c.id, onclick: function () { self.state.layers.text.color = c.id; self._inkChosen = true; self.syncInks(); self.render(true); } }));
    });
    design.appendChild(el('fieldset', { class: 'fls-group' }, [el('legend', { text: 'Text' }), this.textSingle, this.teamBox, this.fontRow, this.inkRow]));

    // Positionieren
    this.layerTabs = el('div', { class: 'fls-chips fls-chips--small', role: 'radiogroup', 'aria-label': 'Was verschieben?' }, [
      el('button', { type: 'button', class: 'fls-chip', 'data-layer': 'image', text: 'Motiv', onclick: function () { self.setActive('image'); } }),
      el('button', { type: 'button', class: 'fls-chip', 'data-layer': 'text', text: 'Text', onclick: function () { self.setActive('text'); } })
    ]);
    this.scaleRange = this.rangeRow('Größe', 'scale', 20, 300, 100, function (v) { self.activeLayer().scale = v / 100; self.render(true); });
    this.rotRange = this.rangeRow('Drehung', 'rot', -180, 180, 0, function (v) { self.activeLayer().rot = v; self.render(true); });
    design.appendChild(el('fieldset', { class: 'fls-group fls-editor' }, [
      el('legend', { text: 'Platzieren' }),
      this.placeHint = el('p', { class: 'fls-hint' }),
      this.layerTabs, this.editor, this.scaleRange, this.rotRange
    ]));
    panel.appendChild(design);

    // Kaufen
    this.qtyInput = el('input', { type: 'number', min: '1', max: '99', value: '1', class: 'fls-qty__input', 'aria-label': 'Anzahl Sets',
      oninput: function () { self.state.qty = clamp(parseInt(this.value, 10) || 1, 1, 99); self.updatePrice(); } });
    this.tierNote = el('p', { class: 'fls-tier' });
    this.stockNote = el('p', { class: 'fls-stocknote', hidden: '' });
    this.rights = el('input', { type: 'checkbox', required: '' });
    this.uvAck = el('input', { type: 'checkbox' });
    this.addBtn = el('button', { type: 'button', class: 'fls-buy', text: 'In den Warenkorb', onclick: function () { self.addToCart(); } });
    this.saveBtn = el('button', { type: 'button', class: 'fls-link', text: 'Design merken', onclick: function () { self.saveDesign(); } });
    this.msg = el('p', { class: 'fls-msg', role: 'status', 'aria-live': 'polite' });
    this.qtyRow = el('div', { class: 'fls-qty' }, [el('label', { text: 'Sets' }), this.qtyInput]);
    var buy = el('div', { class: 'fls-buybox' }, [
      el('ul', { class: 'fls-promises' }, [
        el('li', { text: 'Du bekommst vorab eine Vorschau per Mail – wir fertigen erst nach deinem OK.' }),
        el('li', { text: 'Motiv wird von uns geprüft und für Gravur bzw. Druck optimiert.' }),
        (this.tierLi = el('li', { text: 'Ab 5 Sets 10 %, ab 10 Sets 15 % Rabatt – automatisch im Warenkorb.' }))
      ]),
      this.qtyRow,
      this.tierNote,
      this.stockNote,
      el('label', { class: 'fls-check fls-check--legal' }, [this.rights,
        'Ich habe die Rechte an Motiv und Text. Mir ist bekannt, dass personalisierte Ware vom Widerruf ausgeschlossen ist.']),
      this.uvAckLabel = el('label', { class: 'fls-check fls-check--legal fls-check--uv', hidden: '' }, [this.uvAck,
        'Ich habe zur Kenntnis genommen, dass sich der UV-Farbdruck bei normalem Gebrauch abnutzen kann und dies keinen Mangel darstellt.']),
      this.addBtn,
      el('div', { class: 'fls-row fls-row--end' }, [this.saveBtn]),
      this.msg,
      // Gewährleistungs-Hinweis unter den Knopf, damit „In den Warenkorb“ auf dem Handy nicht so weit unten steht
      this.gwlSlot = el('div', { class: 'fls-gwl' })
    ]);
    panel.appendChild(buy);

    // Gespeicherte Designs
    this.savedBox = el('div', { class: 'fls-saved', hidden: '' }, [el('h2', { class: 'fls-saved__title', text: 'Deine Designs' }), el('div', { class: 'fls-saved__list' })]);
    panel.appendChild(this.savedBox);

    // EU-Gewährleistungslabel (aus dem Theme gerendert) einhängen
    var gwl = $('[data-fl-gwl]', r);
    if (gwl) this.gwlSlot.appendChild(gwl);

    var layout = el('div', { class: 'fls-layout' }, [el('div', { class: 'fls-stagewrap' }, [this.stage]), panel]);
    r.appendChild(layout);
    this.buildMini(panel);

    this.syncFonts();
    this.setActive('text');
    this.setMode('single');
    this.renderTeam();
  };

  // Handy: kleine Vorschau oben rechts, solange man unten gestaltet und die große Vorschau nicht sieht
  Studio.prototype.buildMini = function (panel) {
    var self = this;
    if (!document.getElementById('fls-mobile-css')) {
      document.head.appendChild(el('style', { id: 'fls-mobile-css', text:
        '.fls-mini{position:fixed;top:82px;right:6px;z-index:40;width:70px;padding:5px;border:0;border-radius:12px;' +
        'background:rgba(15,17,21,.92);box-shadow:0 6px 20px rgba(0,0,0,.45);cursor:pointer;transition:opacity .2s}' +
        '.fls-mini[hidden]{display:none}.fls-mini canvas{display:block;width:100%;height:auto}' +
        '.fls-mini span{display:block;margin-top:3px;font:600 10px/1.2 system-ui,sans-serif;color:#cfd6e0;text-align:center}' +
        '@media(min-width:750px){.fls-mini{display:none!important}}' +
        '@media(max-width:749px){#wb-trigger-btn.wb-btn-trigger{padding:6px 12px!important;font-size:12px!important;opacity:.92}}' }));
    }
    this.miniCanvas = el('canvas', { width: PW * RES, height: H * RES, 'aria-hidden': 'true' });
    this.mini = el('button', { type: 'button', class: 'fls-mini', hidden: '', 'aria-label': 'Zur großen Vorschau',
      onclick: function () { self.stage.scrollIntoView({ behavior: 'smooth', block: 'center' }); } },
      [this.miniCanvas, el('span', { text: 'Vorschau' })]);
    document.body.appendChild(this.mini);
    if (!('IntersectionObserver' in window)) return;
    var seen = { stage: true, panel: false };
    var update = function () {
      var on = window.innerWidth < 750 && !seen.stage && seen.panel;
      if (on === self.mini.hidden) { self.mini.hidden = !on; if (on) self.paintMini(); }
    };
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen[e.target === self.stage ? 'stage' : 'panel'] = e.isIntersecting; });
      update();
    }, { rootMargin: '-80px 0px 0px 0px' });
    io.observe(this.stage); io.observe(panel);
    window.addEventListener('resize', update);
  };

  Studio.prototype.paintMini = function () {
    if (!this.mini || this.mini.hidden) return;
    var keep = this.state.reveal; this.state.reveal = 1;
    this.paintPlane(this.miniCanvas, true);
    this.state.reveal = keep;
  };

  Studio.prototype.rangeRow = function (label, key, min, max, val, cb) {
    var input = el('input', { type: 'range', min: String(min), max: String(max), value: String(val), 'data-key': key });
    input.addEventListener('input', function () { cb(parseInt(this.value, 10)); });
    var lab = el('label', { class: 'fls-range' }, [el('span', { text: label }), input]);
    lab.input = input;
    return lab;
  };

  Studio.prototype.textField = function (label, idx, ph) {
    var self = this;
    var input = el('input', { type: 'text', maxlength: '24', placeholder: ph, autocomplete: 'off' });
    input.addEventListener('input', function () { self.state.layers.text.lines[idx] = this.value; self.render(true, true); });
    return el('label', { class: 'fls-field' }, [el('span', { text: label }), input]);
  };

  Studio.prototype.syncOptionButtons = function () {
    var self = this;
    Object.keys(this.optionGroups || {}).forEach(function (name) {
      $all('.fls-chip', self.optionGroups[name]).forEach(function (b) {
        var on = b.getAttribute('data-value') === self.state.options[name];
        b.setAttribute('aria-checked', on);
        b.classList.toggle('is-on', on);
      });
    });
    this.updatePrice();
  };

  Studio.prototype.syncFonts = function () {
    var f = this.state.layers.text.font;
    $all('.fls-font', this.fontRow).forEach(function (b) {
      var on = b.getAttribute('data-font') === f;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
    });
  };

  // Oberfläche an das Verfahren anpassen (Texte, Textfarbe, Logo/Foto-Schalter nur beim Lasern)
  Studio.prototype.syncMethod = function () { if (this.uvOnly && !this._uvInit && this.methodRow) { this._uvInit = 1; this.setMethod('uv'); return; }
    var uv = this.isUV(), e = this.edge();
    if (this._uv === uv && this._edgeShown === e) return;
    this._uv = uv; this._edgeShown = e;
    this.root.classList.toggle('is-uv', uv);
    if (this.methodNote) this.methodNote.textContent = uv
      ? 'Dein Motiv in Originalfarben, auch Fotos und Farbverläufe. Hinweis: Der Farbdruck sitzt auf der Oberfläche der Flight und ist weniger abriebfest als eine Lasergravur. Treffer anderer Darts, Abpraller und Reibung im Etui können den Druck mit der Zeit abnutzen – das ist normaler Verschleiß und kein Reklamationsgrund. Für maximale Haltbarkeit empfehlen wir die Lasergravur.'
      : 'Edel und dauerhaft: der Laser markiert dein Motiv einfarbig und besonders abriebfest in die Flight.';
    if (this.subNode) this.subNode.textContent = '1 Set = 3 Flights · ' + (uv ? 'UV-Farbdruck' : 'Lasergravur') + ' aus unserer Werkstatt am Bodensee';
    if (this.placeHint) this.placeHint.textContent = (uv
      ? 'So sieht deine Flight nach dem Druck aus – in Farbe, so wie dein Motiv. Zum Verschieben ziehen.'
      : 'So sieht deine Flight nach dem Lasern aus. Zum Verschieben ziehen – die gestrichelte Linie zeigt den Gravurbereich.')
      + (e ? ' Am Flügelrand bleiben produktionsbedingt rundherum ca. ' + String(e).replace('.', ',') + ' mm unbedruckt (türkis markiert).' : '');
    if (this.inkRow) this.inkRow.hidden = !uv;
    if (this.uvAckLabel) this.uvAckLabel.hidden = !uv;
    if (this.imageTools) $all('.fls-chips--small, .fls-range', this.imageTools).forEach(function (n) { n.hidden = uv; });
    this.syncInks();
  };
  Studio.prototype.syncInks = function () {
    var cur = this.state.layers.text.color;
    if (this.inkRow) $all('.fls-ink', this.inkRow).forEach(function (b) {
      var on = b.getAttribute('data-ink') === cur; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
    });
  };

  Studio.prototype.setMode = function (mode) {
    this.state.mode = mode;
    $all('.fls-tab', this.modeRow).forEach(function (b) {
      var on = b.getAttribute('data-mode') === mode;
      b.classList.toggle('is-on', on); b.setAttribute('aria-selected', on);
    });
    this.textSingle.hidden = mode === 'team';
    this.teamBox.hidden = mode !== 'team';
    this.qtyRow.hidden = mode === 'team';
    this.addBtn.textContent = mode === 'team' ? 'Team-Sets in den Warenkorb' : 'In den Warenkorb';
    this.updatePrice();
    this.render(true);
  };

  Studio.prototype.setActive = function (layer) {
    if (layer === 'image' && !this.state.layers.image) layer = 'text';
    this.state.active = layer;
    $all('[data-layer]', this.layerTabs).forEach(function (b) {
      var on = b.getAttribute('data-layer') === layer;
      b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
    });
    var L = this.activeLayer();
    this.scaleRange.input.value = Math.round(L.scale * 100);
    this.rotRange.input.value = Math.round(L.rot);
    $('[data-layer="image"]', this.layerTabs).disabled = !this.state.layers.image;
    this.renderEditor();
  };
  Studio.prototype.activeLayer = function () { return this.state.layers[this.state.active] || this.state.layers.text; };

  /* ---------- Team -------------------------------------------------- */

  Studio.prototype.renderTeam = function () {
    var self = this, box = this.teamBox;
    box.innerHTML = '';
    box.appendChild(el('p', { class: 'fls-hint', text: 'Ein Motiv für alle, jeder Spieler bekommt seinen eigenen Namen. Jede Zeile ist ein Set.' }));
    var list = el('ol', { class: 'fls-team__list' });
    this.state.players.forEach(function (p, i) {
      var name = el('input', { type: 'text', maxlength: '24', placeholder: 'Spielername', value: p.name, 'aria-label': 'Spieler ' + (i + 1) });
      name.addEventListener('input', function () { p.name = this.value; self.state.playerIndex = i; self.render(true, true); self.markPlayer(); });
      name.addEventListener('focus', function () { self.state.playerIndex = i; self.render(true); self.markPlayer(); });
      var extra = el('input', { type: 'text', maxlength: '24', placeholder: 'Zusatz (optional)', value: p.extra, 'aria-label': 'Zusatz Spieler ' + (i + 1) });
      extra.addEventListener('input', function () { p.extra = this.value; self.state.playerIndex = i; self.render(true, true); });
      var del = el('button', { type: 'button', class: 'fls-icon', 'aria-label': 'Spieler entfernen', text: '×', onclick: function () {
        if (self.state.players.length > 1) { self.state.players.splice(i, 1); self.state.playerIndex = 0; self.renderTeam(); self.updatePrice(); self.render(true); }
      } });
      list.appendChild(el('li', { class: 'fls-team__row', 'data-i': String(i) }, [name, extra, del]));
    });
    box.appendChild(list);
    box.appendChild(el('button', { type: 'button', class: 'fls-chip', text: '+ Spieler hinzufügen', onclick: function () {
      self.state.players.push({ name: '', extra: '' });
      self.state.playerIndex = self.state.players.length - 1;
      self.renderTeam(); self.updatePrice();
      var inputs = $all('.fls-team__row input[type=text]', box); if (inputs.length) inputs[inputs.length - 2].focus();
    } }));
    this.markPlayer();
  };
  Studio.prototype.markPlayer = function () {
    var i = this.state.playerIndex;
    $all('.fls-team__row', this.teamBox).forEach(function (row) { row.classList.toggle('is-on', row.getAttribute('data-i') === String(i)); });
  };
  Studio.prototype.currentLines = function () {
    if (this.state.mode === 'team') {
      var p = this.state.players[this.state.playerIndex] || this.state.players[0];
      return [p.name, p.extra];
    }
    return this.state.layers.text.lines;
  };

  /* ---------- Preis ------------------------------------------------- */

  Studio.prototype.setCount = function () {
    if (this.state.mode === 'team') return this.state.players.filter(function (p) { return p.name.trim(); }).length || this.state.players.length;
    return this.state.qty;
  };
  Studio.prototype.updatePrice = function () {
    var v = this.currentVariant();
    if (!v || !this.priceNode) return;
    var n = this.setCount();
    var tier = this.isUV() ? null : TIERS.filter(function (t) { return n >= t.min; })[0];
    var total = v.price * n;
    var cur = this.cfg.currency;
    this.priceNode.textContent = money(v.price, cur) + (n > 1 ? '  ·  ' + n + ' Sets ' + money(tier ? Math.round(total * (100 - tier.pct) / 100) : total, cur) : '');
    var next = this.isUV() ? null : TIERS.slice().reverse().filter(function (t) { return n < t.min; })[0]; if (this.tierLi) this.tierLi.hidden = this.isUV();
    this.tierNote.textContent = tier
      ? tier.pct + ' % Mengenrabatt aktiv' + (next ? ' – noch ' + (next.min - n) + ' Sets bis ' + next.pct + ' %.' : '.')
      : (next ? 'Noch ' + (next.min - n) + ' Sets bis ' + next.pct + ' % Rabatt.' : '');
    this.addBtn.disabled = v.available === false;
    this.updateStock();
  };

  // Lagerbestand der normalen K-Flex (gemeinsamer Bestand): reicht er nicht, Hinweis auf Nachbestellung
  Studio.prototype.updateStock = function () {
    if (!this.stockNote) return;
    var st = this.cfg.stock && this.cfg.stock[this.shapeKey()];
    var key = (this.optionValue(/farbe|color|colour/i) || '') + '|' + (this.optionValue(/länge|laenge|length/i) || '');
    var have = st ? st[key] : undefined;
    var need = this.setCount();
    var short = typeof have === 'number' && have < need;
    this.stockNote.hidden = !short;
    if (short) this.stockNote.textContent = this.cfg.backorderNote || 'Diese Variante bestellen wir für dich nach – die Lieferzeit verlängert sich um ca. 2–3 Werktage.';
  };

  /* ---------- Bild laden ------------------------------------------- */

  Studio.prototype.loadImage = function (file) {
    var self = this;
    if (file.size > 20 * 1024 * 1024) { this.say('Die Datei ist größer als 20 MB. Bitte eine kleinere Version hochladen.', true); return; }
    var url = URL.createObjectURL(file);
    var img = new Image();
    img.onload = function () {
      var kind = self.guessKind(img);
      var an = self.analyzeImage(img);
      // transparenter Grund: Bezugston Weiß (dunkles Motiv) oder Schwarz (helles Motiv, „White on Transparent“)
      if (an.mode === 'alpha') an.bg = self.guessInvert(img) ? [0, 0, 0] : [255, 255, 255];
      var invert = false;
      var cw0 = an.crop.w, ch0 = an.crop.h;
      var T = self.state.layers.text;
      // Wie in der Werkstatt: Motiv mittig über beide Flügel, max. ca. 30 mm; Text darunter
      var withText = self.currentLines().some(function (t) { return t && t.trim(); });
      if (!self._textMoved) { T.x = W; T.y = H * 0.7; T.rot = 0; }
      // Werkstatt-Maß: längste Seite 28–33 mm, Breite bis ca. 31 mm (Flight-Breite)
      var box = withText ? { w: PW * 0.74, h: H * 0.44, y: H * 0.33 } : { w: 31 * MM, h: 30 * MM, y: ENG_H * 0.52 };
      self.state.layers.image = { img: img, file: file, name: file.name, x: W, y: box.y, scale: 1, rot: 0,
        kind: kind, invert: invert, threshold: 128, mode: an.mode, bg: an.bg, crop: an.crop,
        fit: Math.min(box.w / cw0, box.h / ch0) };
      self.imageTools.hidden = false;
      self.drop.classList.add('has-file');
      self.drop.firstChild.textContent = file.name;
      self.drop.lastChild.textContent = 'Anderes Motiv wählen';
      if (img.naturalWidth < 400 && img.naturalHeight < 400) self.say('Das Motiv ist recht klein (' + img.naturalWidth + ' × ' + img.naturalHeight + ' px). Wir prüfen es vor der Gravur – eine größere Datei wird schärfer.');
      else if (kind === 'photo') self.say('Foto oder Farbverlauf erkannt: Wir zeichnen dein Motiv vor der Gravur von Hand als klare Strichgrafik nach und schicken dir die Vorschau zur Freigabe.');
      else if (an.bg && lumOf(an.bg) < 90) self.say('Dein Motiv ist hell angelegt – wir gravieren das Motiv, der Hintergrund bleibt frei.');
      else if (an.trimmed) self.say('Einfarbige Ränder am Bild (z. B. vom Handy-Screenshot) haben wir abgeschnitten.');
      else self.say('');
      if (!withText) self.fitImageToFlight();
      self.setImage({});
      self.setActive('image');
      if (self.scaleRange) self.scaleRange.input.value = Math.round(self.state.layers.image.scale * 100);
      self.render(true, false, true);
    };
    img.onerror = function () { self.say('Diese Datei lässt sich nicht öffnen. Bitte als PNG oder JPG speichern und erneut hochladen.', true); };
    img.src = url;
  };

  // Logo oder Foto? Wenige Farben / Transparenz => Logo
  Studio.prototype.guessKind = function (img) {
    var c = document.createElement('canvas'); c.width = 64; c.height = 64;
    var g = c.getContext('2d'); g.drawImage(img, 0, 0, 64, 64);
    var d = g.getImageData(0, 0, 64, 64).data, transparent = 0, buckets = {};
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 200) transparent++;
      buckets[(d[i] >> 5) + '-' + (d[i + 1] >> 5) + '-' + (d[i + 2] >> 5)] = 1;
    }
    return (transparent > 200 || Object.keys(buckets).length < 24) ? 'logo' : 'photo';
  };

  function lumOf(c) { return 0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2]; }
  function hexRgb(h) { h = h.replace('#', ''); return [parseInt(h.slice(0, 2), 16), parseInt(h.slice(2, 4), 16), parseInt(h.slice(4, 6), 16)]; }

  // Hintergrund bestimmen wie in der Werkstatt: häufigste Farbe der deckenden Fläche.
  // Einfarbige Randbalken (Handy-Screenshot, Foto vom Bildschirm), die nicht Hintergrund sind, werden abgeschnitten.
  Studio.prototype.analyzeImage = function (img) {
    var nw = img.naturalWidth, nh = img.naturalHeight, k = Math.min(1, 256 / Math.max(nw, nh));
    var n = Math.max(1, Math.round(nw * k)), m = Math.max(1, Math.round(nh * k));
    var c = document.createElement('canvas'); c.width = n; c.height = m;
    var g = c.getContext('2d'); g.drawImage(img, 0, 0, n, m);
    var d = g.getImageData(0, 0, n, m).data, clear = 0, buckets = {};
    for (var i = 0; i < d.length; i += 4) {
      if (d[i + 3] < 128) { clear++; continue; }
      var key = (d[i] >> 4) + ',' + (d[i + 1] >> 4) + ',' + (d[i + 2] >> 4);
      var b = buckets[key] || (buckets[key] = [0, 0, 0, 0]);
      b[0] += d[i]; b[1] += d[i + 1]; b[2] += d[i + 2]; b[3]++;
    }
    // Motiv-Umriss: Manuel skaliert immer das Motiv selbst auf ~30 mm, nicht das Bild samt Rand
    function contentCrop(isFg, l0, t0, r0, b0) {
      var x0 = n, y0 = m, x1 = -1, y1 = -1;
      for (var yy = t0; yy < m - b0; yy++) for (var xx = l0; xx < n - r0; xx++) {
        if (isFg((yy * n + xx) * 4)) { if (xx < x0) x0 = xx; if (xx > x1) x1 = xx; if (yy < y0) y0 = yy; if (yy > y1) y1 = yy; }
      }
      if (x1 < 0) { x0 = l0; y0 = t0; x1 = n - r0 - 1; y1 = m - b0 - 1; }
      var pad = Math.round(Math.max(x1 - x0, y1 - y0) * 0.02) + 1;
      x0 = Math.max(l0, x0 - pad); y0 = Math.max(t0, y0 - pad); x1 = Math.min(n - r0 - 1, x1 + pad); y1 = Math.min(m - b0 - 1, y1 + pad);
      return { x: Math.round(x0 / k), y: Math.round(y0 / k), w: Math.max(1, Math.round((x1 - x0 + 1) / k)), h: Math.max(1, Math.round((y1 - y0 + 1) / k)) };
    }
    if (clear > n * m * 0.2) return { mode: 'alpha', bg: null, crop: contentCrop(function (j) { return d[j + 3] >= 128; }, 0, 0, 0, 0) };
    var best = null;
    Object.keys(buckets).forEach(function (kk) { if (!best || buckets[kk][3] > best[3]) best = buckets[kk]; });
    var bg = [best[0] / best[3], best[1] / best[3], best[2] / best[3]];
    var dist = function (j, col) { var a = d[j] - col[0], b2 = d[j + 1] - col[1], c2 = d[j + 2] - col[2]; return Math.sqrt(a * a + b2 * b2 + c2 * c2); };
    // Zeile/Spalte gleichmäßig, aber nicht Hintergrund -> Randbalken
    function band(len, at) {
      var first = at(0), col = [d[first], d[first + 1], d[first + 2]], same = 0;
      for (var q = 0; q < len; q++) if (dist(at(q), col) < 40) same++;
      return same > len * 0.92 && dist(first, bg) > 60;
    }
    var top = 0, bot = 0, lef = 0, rig = 0;
    while (top < m * 0.3 && band(n, function (q) { return (top * n + q) * 4; })) top++;
    while (bot < m * 0.3 && band(n, function (q) { return ((m - 1 - bot) * n + q) * 4; })) bot++;
    while (lef < n * 0.3 && band(m, function (q) { return (q * n + lef) * 4; })) lef++;
    while (rig < n * 0.3 && band(m, function (q) { return (q * n + n - 1 - rig) * 4; })) rig++;
    // dünne Linien (z. B. ein Rahmen im Logo) bleiben – erst ab 3 % Stärke ist es ein Balken
    if (top < m * 0.03) top = 0; if (bot < m * 0.03) bot = 0; if (lef < n * 0.03) lef = 0; if (rig < n * 0.03) rig = 0;
    var bgC = Math.max(bg[0], bg[1], bg[2]) - Math.min(bg[0], bg[1], bg[2]);
    var crop = contentCrop(function (j) {
      var ch = Math.max(d[j], d[j + 1], d[j + 2]) - Math.min(d[j], d[j + 1], d[j + 2]);
      return dist(j, bg) * 0.577 > (ch < 40 && bgC < 40 ? 127 : 76);
    }, lef, top, rig, bot);
    return { mode: 'color', bg: bg, crop: crop, trimmed: !!(top || bot || lef || rig) };
  };

  // Graviert wird immer das Motiv, nie der Hintergrund (so sind alle Werkstatt-Dateien gebaut).
  // Hintergrund = was am Bildrand liegt:
  //  - Rand deckend und dunkel  -> Motiv ist hell auf dunkel -> helle Teile gravieren (umkehren)
  //  - Rand transparent und das Motiv selbst überwiegend hell („White on Transparent“) -> ebenfalls umkehren
  //  - sonst (heller Grund, dunkles Motiv auf transparent) -> dunkle Teile gravieren
  Studio.prototype.guessInvert = function (img) {
    var n = 96, c = document.createElement('canvas'); c.width = n; c.height = n;
    var g = c.getContext('2d'); g.drawImage(img, 0, 0, n, n);
    var d = g.getImageData(0, 0, n, n).data, sum = 0, cnt = 0, clear = 0;
    var lum = function (i) { return 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2]; };
    for (var k = 0; k < n * 4; k++) {
      var x = k < n * 2 ? k % n : (k < n * 3 ? 0 : n - 1);
      var y = k < n ? 0 : (k < n * 2 ? n - 1 : k % n);
      var i = (y * n + x) * 4;
      if (d[i + 3] < 128) { clear++; continue; }
      sum += lum(i); cnt++;
    }
    if (cnt > clear) return sum / cnt < 90;
    var fs = 0, fc = 0;
    for (var j = 0; j < d.length; j += 4) if (d[j + 3] >= 128) { fs += lum(j); fc++; }
    return fc > 0 && fs / fc > 170;
  };

  Studio.prototype.setImage = function (patch) {
    var L = this.state.layers.image; if (!L) return;
    Object.keys(patch).forEach(function (k) { L[k] = patch[k]; });
    $all('[data-kind]', this.imageTools).forEach(function (b) {
      var on = b.getAttribute('data-kind') === L.kind; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', on);
    });
    var th = $('input[data-key="threshold"]', this.imageTools);
    th.value = L.threshold;
    th.parentNode.firstChild.textContent = L.kind === 'logo' ? 'Schwelle' : 'Helligkeit';
    this.render(true);
  };

  Studio.prototype.removeImage = function () {
    this.state.layers.image = null;
    this.imageTools.hidden = true;
    this.fileInput.value = '';
    this.drop.classList.remove('has-file');
    this.drop.firstChild.textContent = 'Logo oder Foto hochladen';
    this.drop.lastChild.textContent = 'PNG, JPG, WEBP oder SVG – einfach hierher ziehen';
    this.setActive('text');
    this.render(true);
  };

  /* ---------- Rendering: Design -> Gravurmaske ---------------------- */

  Studio.prototype.path = function () {
    var key = this.shapeKey();
    if (!this._paths) this._paths = {};
    if (!this._paths[key]) this._paths[key] = new Path2D(SHAPES[key]);
    return this._paths[key];
  };

  // Zeichnet alle Ebenen als "Tinte" (schwarz = gravieren) in Vorlagen-Koordinaten
  Studio.prototype.drawDesign = function (g, opts) {
    var s = this.state, L;
    opts = opts || {};
    var withImage = opts.image !== false, withText = opts.text !== false;
    g.save();
    g.scale(RES, RES);
    L = s.layers.image;
    if (L && withImage) {
      g.save();
      g.translate(L.x, L.y); g.rotate(L.rot * Math.PI / 180);
      var sc = L.fit * L.scale;
      var cr = L.crop || { x: 0, y: 0, w: L.img.naturalWidth, h: L.img.naturalHeight };
      var w = cr.w * sc, h = cr.h * sc;
      g.drawImage(L.img, cr.x, cr.y, cr.w, cr.h, -w / 2, -h / 2, w, h);
      g.restore();
    }
    var T = s.layers.text, lines = this.currentLines().filter(function (t) { return t && t.trim(); });
    if (lines.length && withText) {
      g.save();
      g.translate(T.x, T.y); g.rotate(T.rot * Math.PI / 180); g.scale(T.scale, T.scale);
      g.fillStyle = opts.color ? (T.color || '#000') : '#000'; g.textAlign = 'center'; g.textBaseline = 'middle';
      var size1 = 34, size2 = 18;
      g.font = size1 + 'px "' + T.font + '"';
      var w1 = g.measureText(lines[0]).width;
      if (w1 > 190) { size1 = Math.floor(size1 * 190 / w1); g.font = size1 + 'px "' + T.font + '"'; }
      if (lines.length > 1) {
        g.fillText(lines[0], 0, -size2 * 0.75);
        g.font = size2 + 'px "' + T.font + '"';
        g.fillText(lines[1], 0, size1 * 0.55);
      } else {
        g.fillText(lines[0], 0, 0);
      }
      g.restore();
    }
    g.restore();
  };

  // Dünne Umrisslinie (gestrichelt wirkend) einer Alpha-Fläche
  function outline(src, rgb) {
    var w = src.width, h = src.height, d = src.getContext('2d').getImageData(0, 0, w, h).data;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var g = c.getContext('2d'), o = g.createImageData(w, h), q = o.data;
    for (var y = 1; y < h - 1; y++) for (var x = 1; x < w - 1; x++) {
      var i = (y * w + x) * 4;
      if (d[i + 3] < 128) continue;
      if (d[i - 4 + 3] < 128 || d[i + 4 + 3] < 128 || d[i - w * 4 + 3] < 128 || d[i + w * 4 + 3] < 128) {
        if (((x + y) >> 3) & 1) continue; // Strichelung
        q[i] = rgb[0]; q[i + 1] = rgb[1]; q[i + 2] = rgb[2]; q[i + 3] = 200;
      }
    }
    g.putImageData(o, 0, 0);
    return c;
  }

  var BAYER = [0, 8, 2, 10, 12, 4, 14, 6, 3, 11, 1, 9, 15, 7, 13, 5];

  // Rand an der Flügelaußenkante freistellen: Kontur nach innen um edgeMm einrücken,
  // an der Mittelrippe (x = 0) bleibt alles bedruckbar. g ist bereits auf Vorlagen-Einheiten skaliert.
  // Ganze Flight-Seite (beide Flügel + Mittelrippe) als eine Fläche, ohne Rand, ohne Hals-Grenze
  Studio.prototype.fullShape = function (res) {
    var c = document.createElement('canvas'); c.width = PW * res; c.height = H * res;
    var g = c.getContext('2d'), p = this.path();
    g.scale(res, res);
    g.fillStyle = '#000';
    g.save(); g.translate(W, 0); g.fill(p); g.restore();
    g.save(); g.translate(W, 0); g.scale(-1, 1); g.fill(p); g.restore();
    g.fillRect(W - SPINE, 6, SPINE * 2, 252);
    g.setTransform(1, 0, 0, 1, 0, 0); // Aufrufer arbeiten in Pixeln
    return c;
  };

  // Fläche gleichmäßig nach innen einrücken (rundherum, auch oben an der Rippe), r in Pixeln
  function erode(c, r) {
    if (!r) return c;
    var o = document.createElement('canvas'); o.width = c.width; o.height = c.height;
    var og = o.getContext('2d');
    og.fillStyle = '#000'; og.fillRect(0, 0, o.width, o.height);
    og.globalCompositeOperation = 'destination-out'; og.drawImage(c, 0, 0);
    var g = c.getContext('2d');
    g.save(); g.setTransform(1, 0, 0, 1, 0, 0);
    g.globalCompositeOperation = 'destination-out';
    var steps = 36;
    [1, 0.66, 0.33].forEach(function (f) {
      for (var k = 0; k < steps; k++) {
        var a = k / steps * Math.PI * 2;
        g.drawImage(o, Math.cos(a) * r * f, Math.sin(a) * r * f);
      }
    });
    g.restore();
    return c;
  }

  // Gravier-/bedruckbare Fläche einer Flight-Seite (beide Flügel + Rippe, ohne Hals) als Schablone
  Studio.prototype.planeShape = function (res) {
    var key = this.shapeKey() + '@' + res + '@' + this.edge();
    this._shapes = this._shapes || {};
    if (this._shapes[key]) return this._shapes[key];
    var c = erode(this.fullShape(res), this.edge() * MM * res);
    c.getContext('2d').clearRect(0, ENG_H * res, c.width, c.height);
    return (this._shapes[key] = c);
  };

  // Gravurmaske der ganzen Flight-Seite (Alpha = gravieren)
  Studio.prototype.buildMask = function () {
    this.buildPlaneMask(this.maskCanvas, RES);
  };

  Studio.prototype.buildPlaneMask = function (target, res, opts) {
    opts = opts || {};
    var cw = PW * res, ch = H * res;
    target.width = cw; target.height = ch;
    var tmp = document.createElement('canvas');
    tmp.width = cw; tmp.height = ch;
    var g = tmp.getContext('2d', { willReadFrequently: true });
    var sc = res / RES; // drawDesign zeichnet in RES – für die Laser-Maske hochskalieren
    var img = this.state.layers.image;
    // Bild separat, damit Logo/Foto/Invertieren nur das Bild betreffen
    var out = g.createImageData(cw, ch), o = out.data;
    if (img) {
      g.save(); g.scale(sc, sc); this.drawDesign(g, { text: false }); g.restore();
      var d = g.getImageData(0, 0, cw, ch).data;
      var th = img.threshold, photo = img.kind === 'photo', inv = img.invert;
      var bg = img.bg, cutGray = 255 - th, cutColor = (255 - th) * 0.6;
      // Foto: Punktdichte so wählen, dass Flight-Farbe + Lasermarke zusammen wieder das Foto ergeben
      // (auf Schwarz werden helle Bildstellen gelasert, auf Weiß dunkle) – Vorschau = Ergebnis
      var mat = this.material(), baseL = lumOf(hexRgb(mat.base)), markL = lumOf(mat.mark);
      var bgChroma = bg ? Math.max(bg[0], bg[1], bg[2]) - Math.min(bg[0], bg[1], bg[2]) : 0;
      var cell = Math.max(1, Math.round(sc)); // Rasterpunkt so groß wie in der Vorschau
      for (var y = 0; y < ch; y++) {
        for (var x = 0; x < cw; x++) {
          var i = (y * cw + x) * 4, a = d[i + 3];
          if (!a) continue;
          var lum = 0.299 * d[i] + 0.587 * d[i + 1] + 0.114 * d[i + 2];
          var dark = inv ? lum : 255 - lum;
          var v;
          if (photo) {
            var Lp = clamp(lum + (th - 128), 0, 255);
            var pr = clamp((Lp - baseL) / (markL - baseL), 0, 1) * (a / 255);
            var bx = ((x / cell) | 0) & 3, by = ((y / cell) | 0) & 3;
            v = pr * 255 > (BAYER[by * 4 + bx] + 0.5) * 16 ? 255 : 0;
          } else if (bg) {
            // Logo: alles, was sich vom Hintergrund abhebt, ist Motiv. Bei Grautönen wie bisher über die
            // Helligkeit (Schwelle), bei Farben über den Farbabstand (pink auf petrol, rot auf weiß …)
            var dr = d[i] - bg[0], dg = d[i + 1] - bg[1], db = d[i + 2] - bg[2];
            var chroma = Math.max(d[i], d[i + 1], d[i + 2]) - Math.min(d[i], d[i + 1], d[i + 2]);
            var gray = chroma < 40 && bgChroma < 40;
            var fg = Math.sqrt(dr * dr + dg * dg + db * db) * 0.577 * (a / 255) > (gray ? cutGray : cutColor);
            v = fg !== inv ? 255 : 0;
          } else {
            v = (dark * a / 255) > (255 - th) ? 255 : 0;
          }
          o[i + 3] = v;
        }
      }
    }
    // Text immer scharf dazu
    if (!opts.imageOnly) {
      g.clearRect(0, 0, cw, ch);
      g.save(); g.scale(sc, sc); this.drawDesign(g, { image: false }); g.restore();
      var t = g.getImageData(0, 0, cw, ch).data;
      for (var j = 3; j < t.length; j += 4) if (t[j] > 110) o[j] = 255;
    }

    var mg = target.getContext('2d');
    mg.clearRect(0, 0, cw, ch);
    mg.putImageData(out, 0, 0);
    if (opts.noClip) return;
    // Auf die gravierbare Fläche zuschneiden
    mg.save();
    mg.globalCompositeOperation = 'destination-in';
    mg.drawImage(this.planeShape(res), 0, 0);
    mg.restore();
  };

  // Wie Manuel: Motiv so groß wie möglich, aber so, dass praktisch nichts über die Flight hinausläuft
  // (X-förmige oder eckige Motive werden kleiner als runde). Max. 1,5 % der Gravurfläche dürfen wegfallen.
  Studio.prototype.fitImageToFlight = function () {
    var L = this.state.layers.image; if (!L) return;
    var res = 1.5, c = document.createElement('canvas'), shape = this.planeShape(res);
    var sg = shape.getContext('2d').getImageData(0, 0, shape.width, shape.height).data;
    for (var sc = 1; sc >= 0.6; sc -= 0.04) {
      L.scale = sc;
      this.buildPlaneMask(c, res, { imageOnly: true, noClip: true });
      var d = c.getContext('2d').getImageData(0, 0, c.width, c.height).data, all = 0, out = 0;
      for (var i = 3; i < d.length; i += 4) if (d[i]) { all++; if (!sg[i]) out++; }
      if (!all || out / all < 0.015) break;
    }
  };

  function tint(src, rgb) {
    var c = document.createElement('canvas'); c.width = src.width; c.height = src.height;
    var g = c.getContext('2d');
    g.drawImage(src, 0, 0);
    g.globalCompositeOperation = 'source-in';
    g.fillStyle = 'rgb(' + rgb.join(',') + ')';
    g.fillRect(0, 0, c.width, c.height);
    return c;
  }

  // Eingefärbte Gravur (so sieht der Laser auf dem Material aus) – einmal pro Änderung
  Studio.prototype.buildEngraving = function () {
    if (this.isUV()) {
      if (!this._inkChosen) {
        this.state.layers.text.color = lumOf(hexRgb(this.material().base)) < 128 ? '#ffffff' : '#111111';
        this.syncInks();
      }
      this._eng = this.printCanvas(RES); return;
    }
    var m = this.material();
    this._eng = tint(this.maskCanvas, m.mark);
  };

  // UV-Farbdruck: Motiv in Originalfarben + farbiger Text, auf die bedruckbare Fläche zugeschnitten
  Studio.prototype.printCanvas = function (res) {
    var c = document.createElement('canvas'); c.width = PW * res; c.height = H * res;
    var g = c.getContext('2d');
    g.save(); g.scale(res / RES, res / RES); this.drawDesign(g, { color: true }); g.restore();
    g.globalCompositeOperation = 'destination-in';
    g.drawImage(this.planeShape(res), 0, 0);
    return c;
  };

  // Farben für Text beim UV-Druck
  var INK = [
    { id: '#ffffff', label: 'Weiß' }, { id: '#111111', label: 'Schwarz' }, { id: '#38a6b8', label: 'Türkis' },
    { id: '#e30613', label: 'Rot' }, { id: '#ffd200', label: 'Gelb' }, { id: '#1f4fb4', label: 'Blau' },
    { id: '#2fa84f', label: 'Grün' }, { id: '#ff4fa3', label: 'Pink' }, { id: '#ff7a00', label: 'Orange' },
    { id: '#c0c4c8', label: 'Silber' }
  ];

  // Eine Ebene des K-Flex: linker + rechter Flügel, Mittelrippe, Glanz, optional Gravur
  Studio.prototype.paintPlane = function (canvas, withEngraving) {
    var m = this.material(), g = canvas.getContext('2d'), p = this.path();
    g.clearRect(0, 0, canvas.width, canvas.height);
    g.save();
    g.scale(RES, RES);
    var halves = [function () { g.translate(W, 0); }, function () { g.translate(W, 0); g.scale(-1, 1); }];
    halves.forEach(function (place, k) {
      g.save(); place();
      var grad = g.createLinearGradient(0, 0, W, H * 0.8);
      grad.addColorStop(0, m.sheen); grad.addColorStop(0.5, m.base); grad.addColorStop(1, m.base);
      g.fillStyle = grad;
      g.fill(p);
      // Glanzlicht wie bei spritzgegossenem Kunststoff
      var gl = g.createLinearGradient(0, 0, W * 0.9, H * 0.55);
      gl.addColorStop(0, 'rgba(255,255,255,0)'); gl.addColorStop(0.42, 'rgba(255,255,255,0)');
      gl.addColorStop(0.5, 'rgba(255,255,255,' + (k ? .05 : .1) + ')'); gl.addColorStop(0.62, 'rgba(255,255,255,0)');
      g.fillStyle = gl; g.fill(p);
      // Spritzguss-Kante: leicht dickerer Rand
      g.lineWidth = 1.6; g.strokeStyle = 'rgba(255,255,255,' + (k ? .06 : .12) + ')'; g.stroke(p);
      g.lineWidth = .7; g.strokeStyle = 'rgba(0,0,0,.35)'; g.stroke(p);
      g.restore();
    });
    // Mittelrippe: läuft vom Hals bis über die Hinterkante hinaus
    var rib = g.createLinearGradient(W - SPINE, 0, W + SPINE, 0);
    rib.addColorStop(0, m.base); rib.addColorStop(0.45, m.sheen); rib.addColorStop(1, m.base);
    g.fillStyle = rib;
    g.beginPath();
    g.moveTo(W - SPINE, 258); g.lineTo(W - SPINE, 6); g.quadraticCurveTo(W, 1, W + SPINE, 6); g.lineTo(W + SPINE, 258); g.closePath();
    g.fill();
    g.strokeStyle = 'rgba(0,0,0,.25)'; g.lineWidth = .6; g.stroke();
    g.restore();

    if (withEngraving && this._eng) {
      g.save();
      var rv = this.state.reveal;
      if (rv < 1) {
        var yCut = canvas.height * (1 - rv);
        g.beginPath(); g.rect(0, yCut, canvas.width, canvas.height - yCut); g.clip();
      }
      g.drawImage(this._eng, 0, 0);
      g.restore();
    }
  };

  // Schnell: nur Flügel neu malen (z. B. Animation). Voll: Maske neu rechnen.
  Studio.prototype.render = function (full, textOnly, animate) {
    var self = this;
    if (full !== false) {
      if (this._raf) cancelAnimationFrame(this._raf);
      this._raf = requestAnimationFrame(function () {
        self._raf = null;
        self.syncMethod();
        self.buildMask();
        self.buildEngraving();
        self.paintAll();
        self.renderEditor();
        self.updateStage();
        if (animate && !reducedMotion) self.scan();
      });
    } else {
      this.paintAll();
    }
    if (!textOnly) this.updatePrice();
  };

  // 4-seitig: jede Flight-Seite (Ebene vorn/hinten) wird einmal flach gelasert, Motiv über beide Flügel.
  // Vorn: linke Hälfte -> linker Flügel. Hinten (von hinten gesehen gespiegelt): linke Bildhälfte -> rechter Flügel.
  Studio.prototype.paintAll = function () {
    var sides = this.material().sides, self = this;
    var full = this._full || (this._full = document.createElement('canvas'));
    full.width = W * 2 * RES; full.height = H * RES;
    var hw = W * RES, hh = H * RES;
    function put(src, sx, dst) { var g = dst.getContext('2d'); g.clearRect(0, 0, hw, hh); g.drawImage(src, sx, 0, hw, hh, 0, 0, hw, hh); }
    this.planes.forEach(function (pl, i) {
      self.paintPlane(full, sides === 4 || i === 0);
      put(full, 0, pl.L.front); put(full, hw, pl.R.front);
      self.paintPlane(full, sides === 4 || (sides === 2 && i === 0));
      put(full, 0, pl.R.back); put(full, hw, pl.L.back);
    });
    this.paintMini();
  };

  Studio.prototype.updateStage = function () {
    var mm = this.shaftMM();
    this.root.style.setProperty('--fl-mm', mm);
    var m = this.material();
    this.shaft.style.setProperty('--fl-shaft', m.base);
    this.shaft.style.setProperty('--fl-shaft-sheen', m.sheen);
    var hasDesign = this.state.layers.image || this.currentLines().some(function (t) { return t && t.trim(); });
    this.stageNote.textContent = hasDesign
      ? (this.isUV() ? 'Farbdruck auf allen 4 Seiten' : (m.sides === 4 ? 'Gravur auf allen 4 Seiten' : 'Gravur vorn und hinten'))
      : 'Lade ein Motiv hoch oder tippe einen Namen ein';
  };

  /* ---------- Laser-Scan beim neuen Motiv --------------------------- */

  Studio.prototype.scan = function () {
    var self = this, t0 = performance.now(), dur = 1100;
    this.stage.classList.add('is-scanning');
    function step(t) {
      var p = clamp((t - t0) / dur, 0, 1);
      self.state.reveal = p;
      self.laser.style.setProperty('--p', p);
      self.paintAll();
      if (p < 1) requestAnimationFrame(step);
      else { self.state.reveal = 1; self.stage.classList.remove('is-scanning'); self.paintAll(); }
    }
    requestAnimationFrame(step);
  };

  /* ---------- 3D drehen --------------------------------------------- */

  Studio.prototype.loop = function () {
    var self = this;
    // Standard: Flight-Seite frontal, leicht hin und her schwenkend – so sieht man das Motiv über beide Flügel.
    // „Drehen“ schaltet die volle Drehung ein.
    this.spin = false;
    this.sway = !reducedMotion;
    $('[data-view="spin"]', this.viewBtns).setAttribute('aria-pressed', 'false');
    var last = performance.now(), swayT = 0;
    function frame(t) {
      var dt = t - last; last = t;
      if (self.spin && !self.dragging && !self._turning) self.state.angle = (self.state.angle + dt * 0.012) % 360;
      else if (self.sway && !self.dragging && !self._turning) { swayT += dt; self.state.angle = 18 * Math.sin(swayT * 0.0007); }
      self.rig.style.transform = 'rotateX(-8deg) rotateY(' + self.state.angle + 'deg)';
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  };

  Studio.prototype.turnTo = function (deg) {
    var self = this;
    this.spin = false; this.sway = false;
    $('[data-view="spin"]', this.viewBtns).setAttribute('aria-pressed', 'false');
    var from = this.state.angle % 360, to = deg;
    if (to - from > 180) to -= 360; if (from - to > 180) to += 360;
    if (reducedMotion) { this.state.angle = deg; return; }
    var t0 = performance.now(); this._turning = true;
    (function step(t) {
      var p = clamp((t - t0) / 500, 0, 1), e = 1 - Math.pow(1 - p, 3);
      self.state.angle = from + (to - from) * e;
      if (p < 1) requestAnimationFrame(step); else self._turning = false;
    })(t0);
  };

  Studio.prototype.bindDrag = function () {
    var self = this, sx = 0, sa = 0;
    this.stage.addEventListener('pointerdown', function (e) {
      if (e.target.closest('button')) return;
      self.dragging = true; self.sway = false; sx = e.clientX; sa = self.state.angle;
      self.stage.setPointerCapture(e.pointerId);
    });
    this.stage.addEventListener('pointermove', function (e) {
      if (!self.dragging) return;
      self.state.angle = sa + (e.clientX - sx) * 0.6;
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) { self.stage.addEventListener(ev, function () { self.dragging = false; }); });
  };

  /* ---------- Editor (2D) ------------------------------------------- */

  Studio.prototype.renderEditor = function () {
    if (!this.editor) return;
    var g = this.editor.getContext('2d'), cw = this.editor.width, ch = this.editor.height, m = this.material(), p = this.path();
    g.clearRect(0, 0, cw, ch);
    g.save(); g.scale(RES, RES);
    g.fillStyle = m.base;
    g.save(); g.translate(W, 0); g.fill(p); g.restore();
    g.save(); g.translate(W, 0); g.scale(-1, 1); g.fill(p); g.restore();
    g.fillStyle = m.sheen; g.fillRect(W - SPINE, 6, SPINE * 2, 252);
    g.restore();
    if (this._eng) g.drawImage(this._eng, 0, 0);
    // Gravurbereich: Flügelkontur leicht eingerückt + Grenze zum Hals
    g.save(); g.scale(RES, RES);
    g.setLineDash([4, 3]); g.lineWidth = .8;
    g.strokeStyle = m.mark[0] > 150 ? 'rgba(255,255,255,.6)' : 'rgba(0,0,0,.5)';
    g.beginPath(); g.moveTo(W - 70, ENG_H); g.lineTo(W + 70, ENG_H); g.stroke();
    g.beginPath(); g.rect(0, 0, PW, ENG_H); g.clip();
    var e = this.edge() * MM;
    if (e) {
      g.restore();
      // Unbedruckter Rand rundherum: türkis + gestrichelte Innenlinie
      var band = this.fullShape(RES), bg2 = band.getContext('2d');
      bg2.clearRect(0, ENG_H * RES, band.width, band.height);
      bg2.globalCompositeOperation = 'destination-out'; bg2.drawImage(this.planeShape(RES), 0, 0);
      bg2.globalCompositeOperation = 'source-in'; bg2.fillStyle = 'rgba(56,166,184,.32)'; bg2.fillRect(0, 0, band.width, band.height);
      g.drawImage(band, 0, 0);
      g.save(); g.globalAlpha = .9;
      g.drawImage(outline(this.planeShape(RES), m.mark[0] > 150 ? [255, 255, 255] : [0, 0, 0]), 0, 0);
      g.restore();
    } else {
      [1, -1].forEach(function (dir) {
        g.save(); g.translate(W, 0); g.scale(dir, 1);
        g.translate(W / 2, 114); g.scale(0.94, 0.94); g.translate(-W / 2, -114);
        g.stroke(p); g.restore();
      });
      g.restore();
    }
    // Rahmen um aktive Ebene
    var L = this.activeLayer(), box = this.layerBox(L);
    if (box) {
      g.save(); g.scale(RES, RES);
      g.translate(L.x, L.y); g.rotate(L.rot * Math.PI / 180);
      g.setLineDash([]); g.lineWidth = 1.2; g.strokeStyle = '#05f91a';
      g.strokeRect(-box.w / 2, -box.h / 2, box.w, box.h);
      g.restore();
    }
  };

  Studio.prototype.layerBox = function (L) {
    if (L === this.state.layers.image && L) {
      var sc = L.fit * L.scale, cr = L.crop || { w: L.img.naturalWidth, h: L.img.naturalHeight }; return { w: cr.w * sc, h: cr.h * sc };
    }
    var lines = this.currentLines().filter(function (t) { return t && t.trim(); });
    if (!lines.length) return null;
    var g = this.editor.getContext('2d');
    g.font = '34px "' + L.font + '"';
    var w = Math.min(190, g.measureText(lines[0]).width);
    return { w: (w + 8) * L.scale, h: (lines.length > 1 ? 62 : 40) * L.scale };
  };

  Studio.prototype.bindEditor = function () {
    var self = this, start = null;
    function pos(e) {
      var r = self.editor.getBoundingClientRect();
      return { x: (e.clientX - r.left) / r.width * PW, y: (e.clientY - r.top) / r.height * H };
    }
    this.editor.addEventListener('pointerdown', function (e) {
      var L = self.activeLayer(); var p = pos(e);
      start = { p: p, x: L.x, y: L.y };
      self.editor.setPointerCapture(e.pointerId);
    });
    this.editor.addEventListener('pointermove', function (e) {
      if (!start) return;
      var L = self.activeLayer(), p = pos(e);
      L.x = clamp(start.x + p.x - start.p.x, 0, PW); L.y = clamp(start.y + p.y - start.p.y, 0, H);
      if (L === self.state.layers.text) self._textMoved = true;
      self.render(true, true);
    });
    ['pointerup', 'pointercancel'].forEach(function (ev) { self.editor.addEventListener(ev, function () { start = null; }); });
    this.editor.addEventListener('wheel', function (e) {
      e.preventDefault();
      var L = self.activeLayer();
      L.scale = clamp(L.scale * (e.deltaY < 0 ? 1.06 : 0.94), 0.2, 3);
      self.scaleRange.input.value = Math.round(L.scale * 100);
      self.render(true, true);
    }, { passive: false });
    this.editor.addEventListener('keydown', function (e) {
      var L = self.activeLayer(), step = e.shiftKey ? 10 : 2, used = true;
      if (e.key === 'ArrowLeft') L.x -= step; else if (e.key === 'ArrowRight') L.x += step;
      else if (e.key === 'ArrowUp') L.y -= step; else if (e.key === 'ArrowDown') L.y += step;
      else if (e.key === '+' || e.key === '=') L.scale = clamp(L.scale * 1.06, 0.2, 3);
      else if (e.key === '-') L.scale = clamp(L.scale * 0.94, 0.2, 3);
      else used = false;
      if (used) { e.preventDefault(); self.scaleRange.input.value = Math.round(L.scale * 100); self.render(true, true); }
    });
  };

  /* ---------- Export (Vorschau-PNG + Design-Daten) ------------------ */

  Studio.prototype.previewBlob = function () {
    // Links: flach gelegte Flight-Seite in Materialfarbe mit Gravur.
    // Rechts: reine Gravurmaske (schwarz = Laser) mit Kontur für die Werkstatt.
    var pw = PW * RES, ph = H * RES, pad = 30, p = this.path();
    var c = document.createElement('canvas'); c.width = pw + pad * 2; c.height = ph + pad * 2;
    var g = c.getContext('2d');
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height);
    var plane = document.createElement('canvas'); plane.width = pw; plane.height = ph;
    var keep = this.state.reveal; this.state.reveal = 1;
    this.paintPlane(plane, true);
    this.state.reveal = keep;
    g.drawImage(plane, pad, pad);
    var mx = pw + pad * 2;
    var ink;
    if (this.isUV()) ink = this.printCanvas(RES);
    else {
      ink = document.createElement('canvas'); ink.width = pw; ink.height = ph;
      var ig = ink.getContext('2d'); ig.drawImage(this.maskCanvas, 0, 0);
      ig.globalCompositeOperation = 'source-in'; ig.fillStyle = '#000'; ig.fillRect(0, 0, ink.width, ink.height);
    }
    g.drawImage(ink, mx, pad);
    g.save(); g.translate(mx, pad); g.scale(RES, RES); g.strokeStyle = '#bbbbbb'; g.lineWidth = .5;
    g.save(); g.translate(W, 0); g.stroke(p); g.restore();
    g.save(); g.translate(W, 0); g.scale(-1, 1); g.stroke(p); g.restore();
    g.restore();
    return new Promise(function (res) { c.toBlob(res, 'image/png'); });
  };

  // Laser-Maske in hoher Auflösung: weiß = nichts, schwarz = gravieren.
  // Polarität ist hier schon richtig: auf dunklen Flights graviert der UV-Laser hell,
  // also ist alles Schwarze genau das, was später hell auf der Flight steht.
  Studio.prototype.laserBlob = function () {
    var m = document.createElement('canvas');
    this.buildPlaneMask(m, LRES);
    var c = document.createElement('canvas'); c.width = m.width; c.height = m.height;
    var g = c.getContext('2d');
    g.fillStyle = '#ffffff'; g.fillRect(0, 0, c.width, c.height);
    var ink = document.createElement('canvas'); ink.width = m.width; ink.height = m.height;
    var ig = ink.getContext('2d'); ig.drawImage(m, 0, 0);
    ig.globalCompositeOperation = 'source-in'; ig.fillStyle = '#000'; ig.fillRect(0, 0, ink.width, ink.height);
    g.drawImage(ink, 0, 0);
    return new Promise(function (res) { c.toBlob(res, 'image/png'); });
  };

  // Druckdatei für den UV-Drucker: farbig, transparenter Hintergrund, gleiche Auflösung/Lage wie die Laser-Maske
  Studio.prototype.printBlob = function () {
    var c = this.printCanvas(LRES);
    return new Promise(function (res) { c.toBlob(res, 'image/png'); });
  };

  Studio.prototype.laserInfo = function () {
    var img = this.state.layers.image;
    return {
      pxPerMm: LRES * MM,             // Pixel pro Millimeter der Laser-Maske
      widthMm: PW / MM, heightMm: H / MM,
      spineXmm: W / MM,               // Mittelrippe
      areaHeightMm: ENG_H / MM,       // gravierbar bis hier (von oben)
      material: this.optionValue(/farbe|color|colour/i) || 'Schwarz',
      method: this.isUV() ? 'uv' : 'laser',
      edgeMm: this.edge(),
      photo: !!(img && img.kind === 'photo')
    };
  };

  Studio.prototype.designData = function (lines) {
    var s = this.state, img = s.layers.image, T = s.layers.text;
    return {
      v: 2,                                // v2: Koordinaten auf der ganzen Flight-Seite (Rippe bei x = 112)
      shape: this.shapeKey(),
      laser: this.laserInfo(),
      options: s.options,
      image: img ? { name: img.name, x: img.x, y: img.y, scale: img.scale, rot: img.rot, kind: img.kind, invert: img.invert, threshold: img.threshold,
        mode: img.mode, bg: img.bg && img.bg.map(Math.round), crop: img.crop } : null,
      method: this.isUV() ? 'uv' : 'laser',
      text: { lines: lines || this.currentLines(), font: T.font, color: T.color, x: T.x, y: T.y, scale: T.scale, rot: T.rot }
    };
  };

  /* ---------- Backend ----------------------------------------------- */

  Studio.prototype.upload = function (lines) {
    var self = this;
    var uv = this.isUV();
    return Promise.all([this.previewBlob(), uv ? this.printBlob() : this.laserBlob()]).then(function (blobs) {
      var preview = blobs[0], laser = blobs[1];
      if (self.offline) {
        return { designId: uid(), originalUrl: '', previewUrl: '' };
      }
      var fd = new FormData();
      fd.append('design', JSON.stringify(self.designData(lines)));
      fd.append('preview', preview, 'vorschau.png');
      if (uv) fd.append('print', laser, 'druck.png');
      else fd.append('laser', laser, 'laser.png');
      if (self.state.layers.image && self.state.layers.image.file) fd.append('original', self.state.layers.image.file, self.state.layers.image.name);
      // 1) kurzlebiges Upload-Ticket über den App-Proxy holen (Shopify signiert die Anfrage)
      // 2) Dateien direkt an den Server schicken (kein Größenlimit des Proxys)
      return fetch(self.proxy + '/token', { credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) throw new Error('token ' + r.status); return r.json(); })
        .then(function (t) {
          return fetch(t.uploadUrl, { method: 'POST', body: fd, headers: { 'X-FL-Token': t.token } });
        })
        .then(function (r) { if (!r.ok) throw new Error('upload ' + r.status); return r.json(); });
    });
  };

  /* ---------- Warenkorb ---------------------------------------------- */

  Studio.prototype.validate = function () {
    var hasText = this.state.mode === 'team'
      ? this.state.players.some(function (p) { return p.name.trim(); })
      : this.state.layers.text.lines.some(function (t) { return t.trim(); });
    if (!this.state.layers.image && !hasText) { this.say('Lade ein Motiv hoch oder gib einen Text ein.', true); return false; }
    if (this.state.mode === 'team' && !hasText) { this.say('Trag mindestens einen Spielernamen ein.', true); return false; }
    if (!this.rights.checked) { this.say('Bitte bestätige die Rechte am Motiv.', true); this.rights.focus(); return false; }
    if (this.isUV() && this.uvAck && !this.uvAck.checked) { this.say('Bitte bestätige den Hinweis zur Haltbarkeit des UV-Farbdrucks.', true); this.uvAck.focus(); return false; }
    return true;
  };

  Studio.prototype.lineProps = function (res, lines, player) {
    var s = this.state, T = s.layers.text, p = {};
    p['Verfahren'] = this.isUV() ? 'UV-Farbdruck' : 'Lasergravur';
    if (this.isUV()) p['Hinweis Haltbarkeit'] = 'Abnutzung des UV-Drucks bei normalem Gebrauch bestätigt';
    if (lines[0]) p['Text'] = lines.filter(Boolean).join(' / ');
    if (lines[0]) p['Schrift'] = T.font;
    if (lines[0] && this.isUV()) p['Textfarbe'] = (INK.filter(function (c) { return c.id === T.color; })[0] || { label: T.color }).label;
    if (player) p['Spieler'] = player;
    if (s.layers.image) p['Motiv'] = s.layers.image.name;
    if (res.originalUrl) p['Motiv-Datei'] = res.originalUrl;
    if (res.previewUrl) p['Vorschau'] = res.previewUrl;
    p['Freigabe'] = 'Vorschau per Mail vor der Gravur';
    p['_studio_design'] = res.designId;
    return p;
  };

  Studio.prototype.addToCart = function () {
    var self = this;
    if (!this.validate()) return;
    var v = this.currentVariant();
    this.addBtn.disabled = true;
    this.addBtn.textContent = 'Wird vorbereitet …';
    this.say('');
    var jobs;
    if (this.state.mode === 'team') {
      var players = this.state.players.filter(function (p) { return p.name.trim(); });
      var keepIdx = this.state.playerIndex;
      // nacheinander rendern + hochladen, damit jede Vorschau den richtigen Namen trägt
      jobs = players.reduce(function (chain, p) {
        return chain.then(function (items) {
          self.state.playerIndex = self.state.players.indexOf(p);
          self.buildMask(); self.buildEngraving();
          var lines = [p.name, p.extra];
          return self.upload(lines).then(function (res) {
            items.push({ id: v.id, quantity: 1, properties: self.lineProps(res, lines, p.name) });
            return items;
          });
        });
      }, Promise.resolve([])).then(function (items) {
        self.state.playerIndex = keepIdx; self.render(true); return items;
      });
    } else {
      var lines = this.state.layers.text.lines.slice();
      jobs = this.upload(lines).then(function (res) {
        self.lastDesignId = res.designId;
        return [{ id: v.id, quantity: self.state.qty, properties: self.lineProps(res, lines) }];
      });
    }
    jobs.then(function (items) {
      if (self.offline) return { items: items };
      return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
    }).then(function () {
      self.say(self.offline ? 'Demo: So würde es im Warenkorb landen.' : 'Im Warenkorb. Du bekommst vor der Gravur eine Vorschau zur Freigabe.');
      self.rememberLocal();
      if (!self.offline) {
        var cartLink = el('a', { href: (window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart', class: 'fls-link', text: 'Zum Warenkorb' });
        self.msg.appendChild(document.createTextNode(' ')); self.msg.appendChild(cartLink);
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      }
    }).catch(function () {
      self.say('Das Hochladen hat nicht geklappt. Prüfe deine Verbindung und versuch es noch einmal – dein Design bleibt erhalten.', true);
    }).then(function () {
      self.addBtn.disabled = false;
      self.addBtn.textContent = self.state.mode === 'team' ? 'Team-Sets in den Warenkorb' : 'In den Warenkorb';
    });
  };

  Studio.prototype.say = function (text, isError) {
    this.msg.textContent = text;
    this.msg.classList.toggle('is-error', !!isError);
  };

  /* ---------- Designs merken / nachbestellen ------------------------- */

  Studio.prototype.thumb = function () {
    var c = document.createElement('canvas'); c.width = 160; c.height = 160;
    var plane = document.createElement('canvas'); plane.width = W * 2 * RES; plane.height = H * RES;
    this.paintPlane(plane, true);
    var g = c.getContext('2d'), sc = 150 / plane.height;
    g.drawImage(plane, (160 - plane.width * sc) / 2, 5, plane.width * sc, 150);
    return c.toDataURL('image/png');
  };

  Studio.prototype.saveDesign = function () {
    var self = this;
    if (!this.validate()) return;
    var entry = { id: uid(), at: Date.now(), thumb: this.thumb(), design: this.designData(), label: this.currentLines().filter(Boolean).join(' ') || (this.state.layers.image && this.state.layers.image.name) || 'Design' };
    var img = this.state.layers.image;
    var done = function (imageData) {
      entry.imageData = imageData || null;
      var list = store('fls-studio-designs') || [];
      list.unshift(entry);
      var ok = store('fls-studio-designs', list.slice(0, 8));
      if (ok === null && list.length) { entry.imageData = null; store('fls-studio-designs', [entry].concat(list.slice(1, 6))); }
      self.loadSavedDesigns();
      self.say(self.cfg.customer ? 'Design in deinem Konto gespeichert.' : 'Design auf diesem Gerät gemerkt. Mit Kundenkonto ist es überall verfügbar.');
    };
    if (!this.offline && this.cfg.customer) {
      this.upload().then(function (res) {
        return fetch(self.proxy + '/designs', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ designId: res.designId, label: entry.label, design: entry.design,
            originalFileId: res.originalFileId || null, previewFileId: res.previewFileId || null }) });
      }).catch(function () {});
    }
    if (img && img.file && img.file.size < 1.5 * 1024 * 1024) {
      var fr = new FileReader(); fr.onload = function () { done(fr.result); }; fr.readAsDataURL(img.file);
    } else done(null);
  };

  Studio.prototype.rememberLocal = function () { /* Platzhalter: Bestellhistorie kommt aus dem Konto */ };

  Studio.prototype.loadSavedDesigns = function () {
    var self = this, list = (store('fls-studio-designs') || []).slice();
    var render = function (items) {
      var box = $('.fls-saved__list', self.savedBox);
      box.innerHTML = '';
      self.savedBox.hidden = !items.length;
      items.forEach(function (it) {
        box.appendChild(el('button', { type: 'button', class: 'fls-saved__item', title: 'Design laden', onclick: function () { self.applyDesign(it); } }, [
          el('img', { src: it.thumb || it.previewUrl, alt: '' }),
          el('span', { text: it.label })
        ]));
      });
    };
    render(list);
    if (!this.offline && this.cfg.customer) {
      fetch(this.proxy + '/designs', { credentials: 'same-origin' }).then(function (r) { return r.ok ? r.json() : []; })
        .then(function (remote) {
          if (!remote || !remote.length) return;
          var seen = {}; list.forEach(function (x) { seen[x.design && x.design.designId] = 1; });
          render(list.concat(remote.filter(function (r) { return !seen[r.designId]; }).map(function (r) {
            return { id: r.designId, label: r.label, thumb: r.previewUrl, design: r.design, imageUrl: r.originalFileId ? self.proxy + '/file/' + r.originalFileId : null };
          })));
        }).catch(function () {});
    }
  };

  Studio.prototype.applyDesign = function (it) {
    var self = this, d = it.design;
    if (!d) return;
    Object.keys(d.options || {}).forEach(function (k) { if (k in self.state.options) self.state.options[k] = d.options[k]; });
    this.syncOptionButtons();
    var T = this.state.layers.text;
    var shift = (d.v || 1) < 2 ? W : 0; // alte Designs lagen auf dem rechten Flügel
    ['font', 'x', 'y', 'scale', 'rot'].forEach(function (k) { if (d.text && d.text[k] !== undefined) T[k] = d.text[k]; });
    if (shift) { T.x += shift; if (d.image) d.image = Object.assign({}, d.image, { x: d.image.x + shift }); }
    T.lines = (d.text && d.text.lines) ? d.text.lines.slice(0, 2) : ['', ''];
    while (T.lines.length < 2) T.lines.push('');
    $all('.fls-textfields input', this.root).forEach(function (inp, i) { inp.value = T.lines[i] || ''; });
    this.syncFonts();
    this.setMode('single');
    var src = it.imageData || it.imageUrl;
    if (d.image && src) {
      fetch(src).then(function (r) { return r.blob(); }).then(function (b) {
        var file = new File([b], d.image.name || 'motiv.png', { type: b.type });
        self.loadImage(file);
        setTimeout(function () { self.setImage(d.image); self.render(true); }, 60);
      });
    } else if (!d.image) { this.removeImage(); }
    else this.say('Das Motiv war zu groß zum Merken auf diesem Gerät – bitte noch einmal hochladen. Position und Text sind übernommen.');
    this.render(true, false, true);
    this.root.scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'start' });
  };

  /* ------------------------------------------------------------------ */

  function boot() {
    loadFonts();
    $all('[data-fl-studio]').forEach(function (node) {
      if (node.__flStudio) return;
      node.__flStudio = new Studio(node);
    });
    // Schriften sind asynchron – danach einmal neu zeichnen
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () {
      $all('[data-fl-studio]').forEach(function (n) { if (n.__flStudio) n.__flStudio.render(true); });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.FlightLabStudio = { boot: boot };
})();
